import { sanitizeCommaDecimal } from './bigJSHelper'

/**
 * Takes input from a TextField and provides a cash friendly float
 * value.
 *
 * @param value input of the TextField
 * @param preserveNegative Whether to preserve negative sign if present
 * @returns string of cash amount to two decimal places
 */
export const amountFromInput = (
  value: string,
  preserveNegative = false
): string => {
  // Detect if the input contains a leading minus sign
  const isNegative = preserveNegative && /^-/.test(value.trim())

  // Remove all non-digit and non-period characters, including all minus signs
  const sanitizedValue = sanitizeCommaDecimal(value)
  const sanitized = sanitizedValue.replace(/[^0-9.]/g, '')

  if (!sanitized || sanitized === '.' || sanitized === '0.') {
    return '0.00'
  }

  const indexOfDecimal = sanitized.indexOf('.')
  let refinedValue = ''

  if (indexOfDecimal > 0) {
    const [left, right = ''] = sanitized.split('.')
    const paddedRight = right.padEnd(2, '0').substring(0, 2)
    refinedValue = `${left}.${paddedRight}`
  } else if (indexOfDecimal === 0) {
    const right = sanitized.slice(1)
    const padded = right.padEnd(2, '0').substring(0, 2)
    refinedValue = `0.${padded}`
  } else {
    refinedValue = `${sanitized}.00`
  }

  return isNegative ? `-${refinedValue}` : refinedValue
}
